import React from 'react';
import PropTypes from 'prop-types';
import {query} from 'api';
import {withProps} from 'recompose';
import {withRouter} from 'react-router';
import FormationGalery from './formationGalery';
import Academies from './academies';
import {
  Container,
  MainTitle,
  MediumTitle,
  BackLink,
  FormationCover,
  FormationContent,
  Image,
  DateBlock,
  Mask,
  BodyTitle,
  BodySubTitle,
  BodyText,
  InfoBlock,
} from './styles';

const Formation = ({data}) => {
  if (!data) return null;
  return (
    <Container>
      <FormationCover>
        <Image src={data.acf.formations_image} />
        <BackLink to="/formations" />
        <MainTitle>{data.acf.formations_titre}</MainTitle>
        <MediumTitle>{data.acf.formations_sous_titre}</MediumTitle>
        <DateBlock>{data.acf.formations_date}</DateBlock>
        <Mask />
      </FormationCover>
      <FormationContent>
        <BodyTitle>{data.acf.formations_titre}</BodyTitle>
        <BodySubTitle>Programme:</BodySubTitle>
        <BodyText
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: data.content.rendered.replace(/&nbsp;/g, ''),
          }}
        />
        <InfoBlock>
          <div>
            <strong>Lieu: </strong>
            {data.acf.formations_adresse}
          </div>
          <div>
            <strong>Date: </strong>
            {data.acf.formations_date}
          </div>
          <div>
            <strong>Durée: </strong>
            {data.acf.formations_duree}
          </div>
        </InfoBlock>
        <FormationGalery
          galeryData={data.acf.formation_gallery}
          subTitle={data.acf.formations_participer}
        />
        <Academies />
      </FormationContent>
    </Container>
  );
};

Formation.propTypes = {
  data: PropTypes.object,
};

export default Formation
  |> query('getPost')
  |> withProps(
    ({
      match: {
        params: {id},
      },
    }) => ({type: 'formations', id}),
  )
  |> withRouter;
